export const bonuses = [
  {
    num: '01',
    title: 'Kit di Adattamenti Rapidi',
    desc: 'Versioni A, B e C per ogni esercizio. Una sola lezione che funziona anche con gruppi di livello misto.',
    value: '12€',
    image: 'https://cdn.magicpatterns.com/uploads/qNW6kLSB7mywagfHCKYE3f/bono_1.webp',
  },
  {
    num: '02',
    title: "20 Riscaldamenti Pronti all'Uso",
    desc: 'Riscaldamenti specifici per ogni sessione. Versione express e versione completa.',
    value: '9€',
    image: 'https://cdn.magicpatterns.com/uploads/uCWcWA3KvDuyCHBAupknJA/Bono_2.webp',
  },
  {
    num: '03',
    title: '20 Routine di Defaticamento e Chiusura',
    desc: 'Chiudi ogni lezione da vero professionista. Script di chiusura inclusi.',
    value: '9€',
    image: 'https://cdn.magicpatterns.com/uploads/54Ja2Ezsw1fyn5EJZZdyeo/bono_3.webp',
  },
  {
    num: '04',
    title: '50 Frasi Pronte per Guidare le Lezioni',
    desc: 'Le parole esatte per motivare, correggere e guidare il tuo gruppo.',
    value: '8€',
    image: 'https://cdn.magicpatterns.com/uploads/8wMG2fL3ZUyq9MfefYwQXn/bono_4.webp',
  },
  {
    num: '05',
    title: 'Planner Completo delle Lezioni',
    desc: 'Visione annuale, mensile, settimanale e giornaliera. Basta improvvisare.',
    value: '12€',
    image: 'https://cdn.magicpatterns.com/uploads/2oEXjvJcB7VbnnvLLXu2RY/bono_5.webp',
  },
]
